var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.activeSubUsers || _vm.activeExtraNumbers
      ? _c(
          "div",
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.activeSubUsers, function(subUser) {
              return _c(
                "div",
                {
                  key: subUser.id,
                  staticClass: "row setting bundle subscription has-subitem"
                },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "account/bundles-request/extra-user-overview",
                          params: {
                            poc: _vm.$root.user.poc,
                            bundleSubuserId: subUser.bundle_subusers_id
                          }
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "avatar avatar--extra-user" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "account-info sub" }, [
                        _c("div", { staticClass: "table" }, [
                          _c("div", { staticClass: "cell" }, [
                            _c("div", { staticClass: "account-info__title" }, [
                              _vm._v("Extra gebruiker")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "account-info__subtitle" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "account-info__subtitle--large"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        subUser.bundle_subusers_email.includes(
                                          "@"
                                        )
                                          ? subUser.bundle_subusers_email
                                          : "VOIP toestel"
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.filteredExtraNumbers, function(extraNumber) {
              return _c(
                "div",
                {
                  key: extraNumber.id,
                  staticClass: "row setting bundle subscription"
                },
                [
                  extraNumber.number_extension_id == 132
                    ? _c("div", [
                        _c("div", {
                          staticClass: "avatar avatar--extra-mobile-number"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "account-info sub" }, [
                          _c("div", { staticClass: "table" }, [
                            _c("div", { staticClass: "cell" }, [
                              _c(
                                "div",
                                { staticClass: "account-info__title" },
                                [_vm._v("Extra mobiel nummer")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "account-info__subtitle" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "account-info__subtitle--large"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(extraNumber.phone_number_display)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    : extraNumber.number_extension_id == 145
                    ? _c("div", [
                        _c("div", {
                          staticClass: "avatar avatar--extra-business-number"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "account-info sub" }, [
                          _c("div", { staticClass: "table" }, [
                            _c("div", { staticClass: "cell" }, [
                              _c(
                                "div",
                                { staticClass: "account-info__title" },
                                [_vm._v("Extra bedrijfsnummer")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "account-info__subtitle" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "account-info__subtitle--large"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(extraNumber.phone_number_display)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    : _c("div", [
                        _c("div", {
                          staticClass: "avatar avatar--extra-local-number"
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "account-info sub" }, [
                          _c("div", { staticClass: "table" }, [
                            _c("div", { staticClass: "cell" }, [
                              _c(
                                "div",
                                { staticClass: "account-info__title" },
                                [_vm._v("Extra Nummer")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "account-info__subtitle" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "account-info__subtitle--large"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(extraNumber.phone_number_display)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                ]
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bundle-requests" },
      [
        _vm.activeSubUsers == false || _vm.activeSubUsers.length < 4
          ? _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "account/bundles-request/extra-user",
                    params: { poc: _vm.$root.user.poc }
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "row has-subitem setting subscription" },
                  [
                    _c("div", { staticClass: "avatar avatar--extra-user" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "account-info sub" }, [
                      _c("div", { staticClass: "table" }, [
                        _c("div", { staticClass: "cell" }, [
                          _c("div", { staticClass: "account-info__title" }, [
                            _vm._v("Extra gebruiker")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "account-info__subtitle" }, [
                            _c("p", [
                              _vm._v(
                                "Een collega, familielid, vriend of toestel toevoegen aan je account"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "account-info__subtitle--large" },
                              [_vm._v("€1,00 exclusief btw p/m")]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.activeExtraNumbers.length < 5
          ? _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "account/bundles-request/extra-number",
                    params: { poc: _vm.$root.user.poc, numberType: "local" }
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "row has-subitem setting subscription" },
                  [
                    _c("div", {
                      staticClass: "avatar avatar--extra-local-number"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "account-info sub" }, [
                      _c("div", { staticClass: "table" }, [
                        _c("div", { staticClass: "cell" }, [
                          _c("div", { staticClass: "account-info__title" }, [
                            _vm._v("Extra lokaal nummer")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "account-info__subtitle" }, [
                            _c("p", [
                              _vm._v(
                                "Voeg een regionaal nummer toe aan je account. Dit werkt op basis van postcode"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "account-info__subtitle--large" },
                              [_vm._v("€1,00 exclusief btw p/m")]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.activeExtraNumbers.length < 5
          ? _c(
              "router-link",
              {
                attrs: {
                  to: {
                    name: "account/bundles-request/extra-number",
                    params: { poc: _vm.$root.user.poc, numberType: "business" }
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "row has-subitem setting subscription" },
                  [
                    _c("div", {
                      staticClass: "avatar avatar--extra-business-number"
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "account-info sub" }, [
                      _c("div", { staticClass: "table" }, [
                        _c("div", { staticClass: "cell" }, [
                          _c("div", { staticClass: "account-info__title" }, [
                            _vm._v("Extra bedrijfsnummer")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "account-info__subtitle" }, [
                            _c("p", [
                              _vm._v(
                                "Voeg een 085 nummer toe aan je account. Dit is een landelijk nummer tegen lokaal tarief"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "account-info__subtitle--large" },
                              [_vm._v("€1,00 exclusief btw p/m")]
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Huidige bundel(s)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Beschikbare bundels")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-287d45ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-287d45ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BundlesOverview.vue
// module id = null
// module chunks = 